import { Form, FormInstance, Input } from "antd";
import { Rule } from "antd/lib/form";
import { useShowInputContext } from "context/ShowInputContext";
import { ChangeEvent, ChangeEventHandler } from "react";
import { useTranslation } from "react-i18next";
import { InstallationSchema, OrderModelForm } from "types/installation";
import {
  getBarrierDetailsCity,
  getBarrierDetailsCustomerAddress,
  getBarrierDetailsCustomerAddressWithTwoSideBlocking,
  getBarrierDetailsHalteverbot24,
} from "utils/global/installationHelper";

export default function BarrierDetails({
  installation,
  form,
}: {
  installation: InstallationSchema;
  form?: FormInstance<OrderModelForm>;
}) {
  const { t } = useTranslation();

  const customerAddress = getBarrierDetailsCustomerAddress(installation);

  const formattedCustomerAddress =
    getBarrierDetailsCustomerAddressWithTwoSideBlocking(installation);

  const barrierDetailsHalteverbot24 =
    getBarrierDetailsHalteverbot24(installation);

  const barrierDetailsCity = getBarrierDetailsCity(installation);

  const onHalteverbot24Change = (e: ChangeEvent<HTMLInputElement>) => {
    form?.setFieldsValue({
      barrierDetailsHalteverbot24: e.target.value,
      barrierDetailsCity: e.target.value,
    });
  };

  return (
    <div>
      <h5 className="underline">
        {t("orders:barrierDetails.barrierDetails")}:
      </h5>
      <div className="flex gap-4">
        <div className="flex-1">
          <BarrierDetailsTogglingInput
            name="barrierDetailsCustomer"
            value={formattedCustomerAddress}
            label={`${t("orders:barrierDetails.customer")}:`}
            disabled={true}
            className="text-green"
          />
          <BarrierDetailsTogglingInput
            name="barrierDetailsHalteverbot24"
            value={barrierDetailsHalteverbot24}
            label={`${t("orders:barrierDetails.appliedForWebsite")}:`}
            onChange={onHalteverbot24Change}
          />
          <BarrierDetailsTogglingInput
            name="barrierDetailsCity"
            value={barrierDetailsCity}
            label={`${t("orders:barrierDetails.city")}:`}
            key={barrierDetailsCity}
            className={
              customerAddress === barrierDetailsCity ? "text-green" : "text-red"
            }
          />
        </div>
      </div>
    </div>
  );
}

export function BarrierDetailsTogglingInput({
  value,
  label,
  name,
  placeholder,
  disabled,
  onChange = undefined,
  rules,
  className,
}: {
  value: string;
  label: string;
  name: string;
  placeholder?: string;
  disabled?: boolean;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  rules?: Rule[];
  className?: string;
}) {
  const { showInput, isLoading } = useShowInputContext();

  return (
    <div>
      <div>
        <b>{label}</b>
      </div>
      {showInput ? (
        <Form.Item name={name} initialValue={value} rules={rules}>
          <Input
            disabled={disabled || isLoading}
            onChange={onChange}
            placeholder={placeholder}
            style={{ width: "100%" }}
          />
        </Form.Item>
      ) : (
        <p className={className}>{value}</p>
      )}
    </div>
  );
}
